import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/expiry-return-config`;

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAuthToken()}`,
});

export const fetchExpiryReturnConfigs = async () => {
  const response = await axiosInstance.get(`${API_URL}/list`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const fetchExpiryReturnConfigById = async (id: string) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const addExpiryReturnConfig = async (data: any) => {
  const response = await axiosInstance.post(`${API_URL}/create`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateExpiryReturnConfig = async (id: string, data: any) => {
  const response = await axiosInstance.put(`${API_URL}/update/${id}`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const removeExpiryReturnConfig = async (id: string) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};
